import React from 'react';
import Layout from '../components/Layout';

const Home = () => {
    return (
        <Layout>
            <h1>Главная Страница</h1>
            {/* Содержимое главной страницы */}
        </Layout>
    );
};

export default Home;
